import {isProduction} from '../../libs/shared/helpers/src/environment/envHelpers';
import {IncidentsConnector} from './incidents/incidentsConnector';
import {LocalIncidents} from './incidents/localIncidents';
import {partnerStatusPageId, statusPageId, StatusPageIncidents} from './incidents/statusPageIncidents';

export function makeIncidentConnectors(): {
  statusPageConnector: IncidentsConnector;
  partnerStatusPageConnector: IncidentsConnector;
} {
  if (!isProduction()) {
    return {
      statusPageConnector: new LocalIncidents(),
      partnerStatusPageConnector: new LocalIncidents(true),
    };
  }

  return {
    statusPageConnector: new StatusPageIncidents(statusPageId),
    partnerStatusPageConnector: new StatusPageIncidents(partnerStatusPageId),
  };
}
